import { render, staticRenderFns } from "./summaryTypeTable.vue?vue&type=template&id=c347292c&"
import script from "./summaryTypeTable.vue?vue&type=script&lang=js&"
export * from "./summaryTypeTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports